import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles, Tag } from "lucide-react";
import { categoryLabel } from "../lib/categories";

export default function ProductCard({ product, index = 0, thick = true }) {
  const isPriced = product.price > 0;
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group fade-up block"
      style={{ animationDelay: `${0.05 * index}s` }}
    >
      <div className="relative overflow-hidden rounded-3xl bg-[#F5F2EA] aspect-[4/5] transition shadow-[0_6px_24px_-12px_rgba(212,175,55,0.25)]"
        style={thick ? {
          border: `4px solid var(--accent-strong)`,
          boxShadow: `0 0 0 1px var(--bg-tertiary), 0 20px 40px -20px color-mix(in srgb, var(--accent-strong) 50%, transparent)`,
        } : { border: `2px solid color-mix(in srgb, var(--accent-strong) 30%, transparent)` }}
      >
        {product.image_url ? (
          <img
            src={product.image_url}
            alt={product.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#5C5547]">
            <Sparkles className="w-10 h-10" />
          </div>
        )}
        <div className="absolute top-4 left-4">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-[#FDFBF7]/90 backdrop-blur text-[10px] uppercase tracking-[0.2em]">
            <Tag className="w-3 h-3" /> {categoryLabel(product.category)}
          </span>
        </div>
        {product.featured && (
          <div className="absolute top-4 right-4">
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-[var(--accent-strong)] text-white text-[10px] uppercase tracking-[0.2em]">
              <Sparkles className="w-3 h-3" /> Featured
            </span>
          </div>
        )}
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="font-serif text-xl tracking-tight text-[#2C2924] group-hover:text-[var(--accent)] transition-colors line-clamp-2">
            {product.title}
          </h3>
          <p className="mt-1 text-sm text-[#5C5547] line-clamp-1">{product.description}</p>
        </div>
        <div className="shrink-0 text-right">
          {isPriced ? (
            <div className="font-serif text-xl">${product.price.toFixed(2)}</div>
          ) : (
            <div className="text-sm text-[#5C5547] inline-flex items-center gap-1">
              View <ArrowUpRight className="w-3 h-3" />
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
